import _ from "lodash";
import axios from "axios";
import qs from "qs";
import * as Comlink from "comlink";
import { Array } from "core-js";
import Vue from "vue";
import vuex from "vuex";
import QuickEncrypt from "quick-encrypt";

Vue.use(vuex);

import st from "./state";
import mu from "./mutations";
import ut from "./util";
import { agent } from "./actions/agent";
import { auth } from "./actions/auth";
import create from "./actions/create";
import { crypto } from "./actions/crypto";
import { delete as deleteAction } from "./actions/delete";
import query from "./actions/query";
import { update } from "./actions/update";
import { util } from "./actions/util";

const [t, f] = [true, false];
const {
  fb,
  fbBase,
  fbBaseConfig,
  fbusersbase,
  fbBaseLex,
  fbBaseState,
  fbBaseTokens,
  storage,
} = ut.fb();

export const act = {
  auth,
  create,
  crypto,
  delete: deleteAction,
  query,
  update,
  util,
  async api(state, payload) {
    console.log("api", { payload });
    // payload = {address, verb, config, data}
    if (payload.hook) {
      payload.hook.from = "api_" + payload.address;
      store.dispatch("run", payload.hook);
      // TODO encapsulate execution context to hook generator function. yield => next
    }
    if (!payload.verb) payload.verb = "get";
    var timeStart = Date.now();
    // console.log(payload.address, payload.data || {}, payload.config || {});

    // let passdata = !payload.data && payload.verb == 'get' ? [payload.address, payload.config] : [payload.address, payload.data || {}, payload.config || {}]
    // console.log({ passdata });

    if (!payload.config) payload.config = {};
    let options = {
      method: payload.verb || "get",
      url: payload.address,
      ...payload.config,
    };
    payload.data
      ? (options.data = options.url.includes("xmba-cloud-api")
          ? qs.stringify(payload.data)
          : payload.data)
      : null;

    // return await axios[payload.verb || 'get'](...passdata)
    return await axios(options)
      .then((ret) => {
        console.log("api return", ret);
        mu.log("api time", Date.now() - timeStart, payload);
        return ret;
      })
      .catch((err) => {
        return err;
      });
  },
  async blockfrostipfs(state, payload) {
    // payload = {file, client}
    mp("Pinning to IPFS", file);
    let client,
      file = payload.file;
    if (!payload.client) {
      client = "agapeipfs3"; // todo let clients set and select their own keys
    } else {
      client = payload.client;
    }
    console.log({ file });
    const ipfs = store.dispatch("api", {
      address:
        store.state.cloudurl +
        `ipfs?client=${client}&url=${encodeURI(file.url[0])}&name=${
          file.name
        }&mime=${file.type}&xmbltoken=${file.token[1]}&hash=${file.hash}`,
    });
    return await ipfs.then((x) => {
      file.ipfs = x.data && x.data.pinned.ipfs_hash;
      mp("Pinned to IPFS", file.ipfs, t);
      d("update", {
        type: "files",
        hash: file.hash,
        data: file,
      });
    });
  },
  detecttype(state, payload) {
    if (Array.isArray(payload)) return "array";
    if (
      typeof payload === "object" &&
      !Array.isArray(payload) &&
      payload !== null
    )
      return "object";
    if (typeof payload === "string" && isNaN(payload)) return "string";
    if (!isNaN(+payload) && payload !== null) return "number";
    if (typeof payload === "boolean") return "boolean";
    if (typeof payload === "function") return "function";
    if (payload == null) return "null";
    return "untyped";
  },
  export(state, payload) {
    // payload: {type, name, data}
    let exportData = payload;
    var filename = (
      "EXPORT_" +
      store.state.app.basics.database +
      " " +
      exportData.type +
      "_" +
      exportData.name +
      "_" +
      new Date().toLocaleDateString() +
      ".json"
    ).norm();
    var element = document.createElement("a");
    // TODO make general, i.e. check export.data reasoning and remove
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," +
        encodeURIComponent(JSON.stringify(exportData.data || exportData))
    );
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  },
  import(state, payload) {
    console.log("importing config", payload);
    var reader = new FileReader();
    console.log(reader);
    reader.onload = ((file) => {
      let myblob = reader.readAsText(file);
      console.log(file, myblob);
      return (e) => {
        // console.log('what is e', e);
        let appdata = JSON.parse(e.target.result);
        var confirmation = confirm(
          "Import " +
            JSON.parse(e.target.result).basics["app name"] +
            " config? This will overwrite the current app config."
        );
        appdata.user = store.state.app.user;
        appdata.owner = store.state.auth.uid;
        appdata.ownedBy = store.state.auth.uid;
        appdata.basics.database = store.state.app.basics.database;
        confirmation &&
          appdata.basics["app name"] &&
          state
            .dispatch("update", {
              type: "app",
              data: appdata,
            })
            .then(() => {
              location.reload();
            });
      };
    })(payload.files[0]);
  },

  async ensureSystemUsers() {
    const store = window.$store;
    const { fbBase } = require("./util").default.fb();

    // System user definitions
    const systemUsers = [
      {
        uid: "5nA8rryyPedDsIvtWmTD0pRbann2",
        id: "5nA8rryyPedDsIvtWmTD0pRbann2",
        basics: {
          name: "XMBL Agent",
          email: "agent@xmbl.org",
          image:
            "https://preview.redd.it/p61ulijkxr751.jpg?width=320&crop=smart&auto=webp&s=342130582bd6c2aadf98b94a936f57bab25ea1aa",
          purpose: "AI Assistant for XMBL platform",
        },
        purpose: "AI Assistant",
        name: "XMBL Agent",
        created: Date.now(),
      },
      {
        uid: "7heXwzCbDQV0NX1IL9NRwyOCaNK2",
        id: "7heXwzCbDQV0NX1IL9NRwyOCaNK2",
        basics: {
          name: "XMBL Team",
          email: "team@xmbl.org",
          image:
            "https://preview.redd.it/p61ulijkxr751.jpg?width=320&crop=smart&auto=webp&s=342130582bd6c2aadf98b94a936f57bab25ea1aa",
          purpose: "Official XMBL support team",
        },
        purpose: "Platform Support",
        name: "XMBL Team",
        created: Date.now(),
      },
    ];

    // Check and create missing system users
    for (const user of systemUsers) {
      try {
        const userDoc = await fbBase.collection("user").doc(user.uid).get();
        if (!userDoc.exists) {
          console.log(`Creating missing system user: ${user.name}`);
          await fbBase.collection("user").doc(user.uid).set(user);

          // Update ref collections for display
          await store.dispatch("indexer", [user, user.uid, "user"]);
        }
      } catch (error) {
        console.log(`Failed to check/create system user ${user.name}:`, error);
      }
    }
  },

  async indexer(state, [obj, id, type]) {
    const wb = fb.firestore().batch();
    let index = {},
      dbindex,
      tally = 0;

    // Function to remove all entries for a user ID from the index
    const removeAllEntriesForUser = (indexObj) => {
      Object.keys(indexObj).forEach((key) => {
        if (Array.isArray(indexObj[key])) {
          const idIndex = indexObj[key].indexOf(id);
          if (idIndex > -1) {
            indexObj[key].splice(idIndex, 1);
            if (indexObj[key].length === 0) {
              delete indexObj[key];
            }
          }
        } else if (
          typeof indexObj[key] === "object" &&
          indexObj[key] !== null
        ) {
          removeAllEntriesForUser(indexObj[key]);
          if (Object.keys(indexObj[key]).length === 0) {
            delete indexObj[key];
          }
        }
      });
    };

    fbBase
      .collection("index")
      .doc(type)
      .get()
      .then((x) => {
        dbindex = !x.exists ? {} : x.data();

        removeAllEntriesForUser(dbindex);

        let indexloop = async (loopobj, keys) => {
          tally++;
          await store.dispatch("detecttype", loopobj).then((typ) => {
            if (typ === "string") {
              // Check property size limit (1400kb = 1,433,600 characters)
              if (loopobj.length > 1433600) {
                console.warn(
                  `Property value too large (${loopobj.length} chars), truncating to 1400kb`
                );
                loopobj = loopobj.substring(0, 1433600);
              }

              // Clean up orphaned entries for this ID at the same level before adding new entry
              const parentPath = keys.slice(0, -1);
              if (parentPath.length > 0) {
                const parentObj = _.get(dbindex, parentPath);
                if (parentObj && typeof parentObj === "object") {
                  Object.keys(parentObj).forEach((propKey) => {
                    if (
                      parentObj[propKey] &&
                      Array.isArray(parentObj[propKey])
                    ) {
                      const idIndex = parentObj[propKey].indexOf(id);
                      if (idIndex > -1) {
                        parentObj[propKey].splice(idIndex, 1);
                        if (parentObj[propKey].length === 0) {
                          delete parentObj[propKey];
                        }
                      }
                    }
                  });
                }
              }

              let loopobjindex = _.get(dbindex, [...keys, loopobj]);
              tally--;
              _.set(
                index,
                [...keys, loopobj],
                loopobjindex ? Array(...new Set([...loopobjindex, id])) : [id]
              );
            } else if (typ === "object") {
              tally--;
              Object.entries(loopobj).map((x) =>
                indexloop(x[1], [...keys, x[0]])
              );
            } else if (typ === "array") {
              tally--;
              loopobj.map((x) => indexloop(x, keys));
            } else tally--;
            if (tally == 0) {
              wb.set(fbBase.collection("index").doc(type), dbindex);
              wb.set(fbBase.collection("index").doc(type), index, { merge: t });

              // Handle ref collections for users
              if (type === "user" && obj.basics) {
                if (obj.basics.name) {
                  Vue.set(store.state.ref.name, id, obj.basics.name);
                  wb.set(
                    fbBase.collection("ref").doc("name"),
                    store.state.ref.name
                  );
                }
                if (obj.basics.image) {
                  let imageUrl;
                  if (
                    Array.isArray(obj.basics.image) &&
                    obj.basics.image.length > 0
                  ) {
                    imageUrl = obj.basics.image[0];
                  } else if (typeof obj.basics.image === "string") {
                    imageUrl = obj.basics.image;
                  }
                  if (imageUrl) {
                    Vue.set(store.state.ref.image, id, imageUrl);
                    wb.set(
                      fbBase.collection("ref").doc("image"),
                      store.state.ref.image
                    );
                  }
                }
              }

              wb.commit();
            }
          });
        };
        Object.keys(obj).map((x, xi) => {
          index[x] = {};
          !["created", "type", "id", "history", "edited"].includes(x) &&
            indexloop(
              obj[x],
              [x],
              xi === Object.keys(obj).length - 1 && "last"
            );
        });
      });
  },
  async init(state, styleonly, stateonly) {
    if (styleonly) {
      // console.log('styleonly', arguments)
      Object.assign(s, state);
    }
    if (stateonly) {
      // console.log('stateonly', arguments)
      Object.assign(s, state);
    }
    console.groupCollapsed("Initializing state");
    return fbBaseConfig
      .get()
      .then((defaults) => {
        let dd = defaults.data();
        Object.entries(dd).map((d) => Vue.set(s, d[0], d[1]));
        s.cloudurl = s.dev
          ? "/xmba-cloud-api/us-central1/"
          : "https://us-central1-xmba-cloud-api.cloudfunctions.net/";
        s.prohibitedProps.push(...s.abilityTypes);
        // Array('object', 'array', 'string').map(x => s.initializestate[x].map(y => Vue.set(s, y, x == 'object' ? {} : x == 'array' ? [] : '')))
      })
      .then(() => {
        return fbBase.get().then(
          async (data) => {
            console.log("...loading data...");
            if (data.exists) {
              var app = data.data().app;
              console.log("...app config...", app.basics.database);

              app.forms = {};
              app.itemTypes = [];
              if (app.basics.items) {
                console.log("...items config...");
                console.table(app.basics.items);
                app.basics.items.forEach((item) => {
                  Vue.set(app.forms, item.name, {
                    forms: item.forms,
                    name: item.name,
                    submit: {
                      method: "create",
                      type: item.name,
                    },
                  });
                  app.itemTypes.push(item.name);
                });
              }
              mu.setState(s, {
                prop: "app",
                val: app,
              });

              // backwards compatibility
              if (!s.app.advanced) s.app.advanced = {};
              Array("functions", "hooks", "roles", "api", "custom-script").map(
                (t) => {
                  if (s.app.basics[t]) {
                    mu.set(s, {
                      keys: ["app", "advanced", t],
                      val: s.app.basics[t],
                    });
                  }
                  if (!s.app.advanced[t]) {
                    mu.set(s, {
                      keys: ["app", "advanced", t],
                      val: t === "custom-script" ? "" : {},
                    });
                  }
                }
              );

              // APPLY META
              console.log("...applying types, meta data, and styles...");
              // TODO fix type system: mu.typei(s)
              Vue.set(s.show, "app", t);
              mu.setMeta(st);
              mu.setScript(st);
              mu.setStyle(st);
              return s.app;
            } else {
              // new app
              const defaultBackground = "/img/stock/xmbl_bg.gif"; // fallback xmbl gif
              console.log(
                "...creating new app with NASA API (Unsplash fallback)..."
              );

              const createAppState = (imageUrl) => {
                console.log(
                  "...setting up new app state with image:",
                  imageUrl
                );
                s.models.iform.app.forms[1].inputs[0].default = imageUrl;

                // Default item types with full schema
                const defaultItems = [
                  {
                    forms: [
                      {
                        description: "The basic bits of an item.",
                        inputs: [
                          {
                            inputType: "input",
                            placeholder: "title",
                            label: "title",
                            default: "",
                            type: "text",
                            display: {
                              list: true,
                              form: true,
                              single: true,
                            },
                            priority: 1,
                          },
                          {
                            inputType: "textarea",
                            priority: 2,
                            placeholder: "Description",
                            display: {
                              form: true,
                              single: true,
                              list: true,
                            },
                            default: "",
                            label: "description",
                            type: "text",
                          },
                          {
                            priority: 3,
                            default: "",
                            placeholder: "Image Url",
                            inputType: "file",
                            type: "image",
                            display: {
                              form: true,
                              single: true,
                              list: true,
                            },
                            label: "image",
                          },
                          {
                            inputType: "tags",
                            label: "tags",
                            default: [],
                            priority: 4,
                            placeholder: "tags",
                            type: "tags",
                            display: {
                              single: true,
                              form: true,
                              list: true,
                            },
                          },
                          {
                            placeholder: "Publish this item",
                            priority: 4,
                            inputType: "check",
                            label: "published",
                            default: true,
                            type: "text",
                            display: {
                              list: true,
                              single: true,
                              form: true,
                            },
                          },
                        ],
                        name: "basics",
                      },
                    ],
                    type: "asset",
                    name: "blog",
                  },
                  {
                    name: "event",
                    type: "asset",
                    abilities: ["events"],
                    forms: [
                      {
                        inputs: [
                          {
                            priority: 1,
                            placeholder: "title",
                            label: "title",
                            inputType: "input",
                            default: "",
                            type: "text",
                            display: {
                              list: true,
                              form: true,
                              single: true,
                            },
                          },
                          {
                            display: {
                              list: true,
                              form: true,
                              single: true,
                            },
                            default: "",
                            type: "text",
                            priority: 2,
                            placeholder: "Description",
                            label: "description",
                            inputType: "textarea",
                          },
                          {
                            placeholder: "Image Url",
                            type: "image",
                            display: {
                              single: true,
                              form: true,
                              list: true,
                            },
                            label: "image",
                            default: "",
                            priority: 3,
                            inputType: "file",
                          },
                          {
                            placeholder: "tags",
                            default: [],
                            priority: 4,
                            display: {
                              form: true,
                              list: true,
                              single: true,
                            },
                            label: "tags",
                            type: "tags",
                            inputType: "tags",
                          },
                          {
                            inputType: "check",
                            type: "text",
                            label: "published",
                            placeholder: "Publish this item",
                            display: {
                              form: true,
                              single: true,
                              list: true,
                            },
                            priority: 4,
                            default: true,
                          },
                        ],
                        name: "basics",
                        description: "The basic bits of an item.",
                      },
                      {
                        icon: "fas fa-calendar",
                        inputs: [
                          {
                            type: "text",
                            priority: 2,
                            label: "location",
                            default: "Online",
                            placeholder: "Event location",
                            display: {
                              form: true,
                              single: true,
                              list: true,
                            },
                            inputType: "textarea",
                          },
                          {
                            label: "date",
                            placeholder: "",
                            inputType: "date-time",
                            display: {
                              single: true,
                              form: true,
                              list: true,
                            },
                            type: "date-time",
                            default: 0,
                            priority: 3,
                          },
                          {
                            placeholder: "Is this a private event?",
                            default: 0,
                            inputType: "check",
                            type: "text",
                            options: ["yes", "no"],
                            display: {
                              single: true,
                              form: true,
                              list: true,
                            },
                            label: "private",
                            priority: 3,
                          },
                        ],
                        name: "events",
                      },
                    ],
                  },
                  {
                    type: "asset",
                    abilities: ["purchases"],
                    name: "product",
                    forms: [
                      {
                        inputs: [
                          {
                            placeholder: "title",
                            inputType: "input",
                            default: "",
                            display: {
                              form: true,
                              list: true,
                              single: true,
                            },
                            type: "text",
                            label: "title",
                            priority: 1,
                          },
                          {
                            default: "",
                            display: {
                              single: true,
                              form: true,
                              list: true,
                            },
                            label: "description",
                            type: "text",
                            placeholder: "Description",
                            priority: 2,
                            inputType: "textarea",
                          },
                          {
                            placeholder: "Image Url",
                            inputType: "file",
                            label: "image",
                            display: {
                              list: true,
                              single: true,
                              form: true,
                            },
                            default: "",
                            priority: 3,
                            type: "image",
                          },
                          {
                            inputType: "tags",
                            priority: 4,
                            display: {
                              list: true,
                              form: true,
                              single: true,
                            },
                            default: [],
                            placeholder: "tags",
                            label: "tags",
                            type: "tags",
                          },
                          {
                            priority: 4,
                            inputType: "check",
                            default: true,
                            label: "published",
                            placeholder: "Publish this item",
                            display: {
                              single: true,
                              form: true,
                              list: true,
                            },
                            type: "text",
                          },
                          {
                            priority: 5,
                            inputType: "check",
                            default: false,
                            label: "bypassTruncation",
                            placeholder: "Bypass text truncation",
                            display: {
                              single: true,
                              form: true,
                              list: false,
                            },
                            type: "text",
                          },
                        ],
                        name: "basics",
                        description: "The basic bits of an item.",
                      },
                      {
                        name: "components",
                        description: "Widget components for this item.",
                        inputs: [],
                      },
                      {
                        name: "purchases",
                        inputs: [
                          {
                            placeholder: "default cost",
                            display: {
                              single: true,
                              list: true,
                              form: true,
                            },
                            label: "cost",
                            type: "number",
                            default: 1,
                            inputType: "input",
                            priority: 1,
                          },
                          {
                            options: [],
                            label: "variations",
                            default: "",
                            placeholder:
                              "List variations available for this item",
                            disabled: false,
                            type: "text",
                            inputType: "select",
                            multiple: true,
                          },
                          {
                            inputType: "input",
                            placeholder: "minimum bid",
                            type: "number",
                            label: "minimum bid",
                            display: {
                              list: true,
                              form: true,
                              single: true,
                            },
                            default: 1,
                            priority: 1,
                          },
                          {
                            options: ["USD", "Crypto", "Xymba"],
                            inputType: "select",
                            default: "USD",
                            label: "currency",
                            type: "text",
                            display: {
                              form: true,
                              list: true,
                              single: true,
                            },
                            priority: 2,
                            placeholder: "currency",
                          },
                          {
                            inputType: "input",
                            default: 0,
                            placeholder: "S&H cost",
                            type: "number",
                            label: "shipping and handling",
                            display: {
                              list: true,
                              single: true,
                              form: true,
                            },
                            priority: 3,
                          },
                          {
                            default: 0,
                            options: ["yes", "no"],
                            display: {
                              form: true,
                              single: true,
                              list: true,
                            },
                            type: "text",
                            placeholder: "Is this item ownable?",
                            inputType: "check",
                            label: "ownership",
                          },
                          {
                            placeholder: "Is this item auctionable?",
                            default: 0,
                            type: "text",
                            inputType: "check",
                            display: {
                              single: true,
                              list: true,
                              form: true,
                            },
                            label: "auction",
                            options: ["yes", "no"],
                          },
                          {
                            placeholder: "When does this auction end?",
                            if: ["auction", true],
                            inputType: "date-time",
                            default: 0,
                            type: "date-time",
                            priority: 2,
                            required: true,
                            display: {
                              list: true,
                              form: true,
                              single: true,
                            },
                            label: "auction end",
                          },
                          {
                            if: ["auction", true],
                            options: ["yes", "no"],
                            type: "text",
                            display: {
                              list: true,
                              single: true,
                              form: true,
                            },
                            default: 0,
                            placeholder:
                              "Let users buy without waiting for end of auction?",
                            label: "buy now",
                            inputType: "check",
                          },
                          {
                            default: 0,
                            placeholder: "Enter your token signature",
                            type: "text",
                            priority: 1,
                            display: {
                              single: true,
                              list: true,
                              form: true,
                            },
                            if: "ownership",
                            inputType: "input",
                            label: "ownership signature",
                          },
                          {
                            display: {
                              list: true,
                              form: true,
                              single: true,
                            },
                            label: "subscription",
                            options: ["yes", "no"],
                            inputType: "check",
                            default: 0,
                            type: "text",
                            placeholder: "Is this item subscribeable?",
                          },
                        ],
                        icon: "fas fa-shopping-cart",
                      },
                    ],
                  },
                  {
                    name: "service",
                    type: "asset",
                    forms: [
                      {
                        description: "The basic bits of an item.",
                        name: "basics",
                        inputs: [
                          {
                            placeholder: "title",
                            type: "text",
                            priority: 1,
                            inputType: "input",
                            default: "",
                            label: "title",
                            display: {
                              single: true,
                              form: true,
                              list: true,
                            },
                          },
                          {
                            inputType: "textarea",
                            placeholder: "Description",
                            label: "description",
                            priority: 2,
                            default: "",
                            type: "text",
                            display: {
                              form: true,
                              single: true,
                              list: true,
                            },
                          },
                          {
                            priority: 3,
                            placeholder: "Image Url",
                            type: "image",
                            inputType: "file",
                            display: {
                              list: true,
                              form: true,
                              single: true,
                            },
                            default: "",
                            label: "image",
                          },
                          {
                            default: [],
                            priority: 4,
                            placeholder: "tags",
                            display: {
                              form: true,
                              list: true,
                              single: true,
                            },
                            inputType: "tags",
                            label: "tags",
                            type: "tags",
                          },
                          {
                            label: "published",
                            display: {
                              form: true,
                              single: true,
                              list: true,
                            },
                            priority: 4,
                            default: true,
                            inputType: "check",
                            type: "text",
                            placeholder: "Publish this item",
                          },
                        ],
                      },
                    ],
                  },
                ];

                mu.setState(s, {
                  prop: "app",
                  val: {
                    basics: {
                      database: "fresh",
                      live: "",
                      items: defaultItems,
                      meta: [],
                      menus: {},
                      logo: "",
                      "app name": "New XMBL",
                      modules: [
                        "auth",
                        "blockchain",
                        "events",
                        "jobs",
                        "messages",
                        "cart",
                        "maps",
                        "profiles",
                        "comments",
                        "reputation",
                        "secrets",
                        "notifications",
                      ],
                      export: "",
                      import: "",
                      title: Date.now(),
                    },
                    advanced: {
                      functions: {
                        f7d020bd782569b09fa0257aed5265f2e1ad704b75495b7abe576a291b6e2ab6:
                          {
                            name: "background",
                            inputs: {},
                            state: {
                              outputs: [
                                {
                                  value: "",
                                  type: "",
                                },
                                {
                                  type: "",
                                  value: "",
                                },
                                {
                                  value: "",
                                  type: "",
                                },
                                {
                                  value: "",
                                  type: "",
                                },
                              ],
                            },
                            test: ["inputs", "return value"],
                            functionhash:
                              "d2c6932138d6a5d87e6511afd8c399f332d9924d08eb6bf43bc05b42a4f66364",
                            show: {},
                            commands: [
                              {
                                method: "dispatch.api",
                                actionName: "api",
                                tests: [],
                                type: "app",
                                storeMethod: "dispatch",
                                inputs: {
                                  verb: {
                                    value: "static",
                                    order: 4,
                                    static: "get",
                                    type: "string",
                                  },
                                  address: {
                                    static:
                                      "https://api.unsplash.com/photos/random?client_id=-Z_FV8M_lDJt-EejYaZUhlUn9MLdrsJZ3tta2cqJKAY&orientation=landscape",
                                    type: "string",
                                    order: 3,
                                    value: "static",
                                  },
                                },
                              },
                              {
                                await: [0],
                                tests: [],
                                type: "app",
                                inputs: {
                                  val: {
                                    target: "data.urls.full",
                                    value: "state.outputs[0]",
                                    static: "",
                                    properties: {},
                                    type: "string",
                                    description: "Value to set",
                                    order: 2,
                                  },
                                  keys: {
                                    static: [
                                      "app",
                                      "style",
                                      "background-image",
                                    ],
                                    description: "Array of keys",
                                    properties: {},
                                    order: 1,
                                    type: "array",
                                    value: "static",
                                  },
                                },
                                storeMethod: "commit",
                                actionName: "set",
                                method: "commit.set",
                              },
                              {
                                actionType: "app",
                                await: [0],
                                actionName: "update",
                                tests: [],
                                type: "app",
                                inputs: {
                                  data: {
                                    static: "p__state.app",
                                    value: "static",
                                    order: 2,
                                    type: "object",
                                  },
                                  type: {
                                    order: 1,
                                    value: "static",
                                    type: "string",
                                    static: "app",
                                  },
                                },
                                storeMethod: "dispatch",
                                method: "dispatch.update",
                              },
                              {
                                inputs: {},
                                method: "dispatch.init",
                                storeMethod: "dispatch",
                                actionName: "init",
                                await: [2],
                                tests: [],
                                type: "app",
                              },
                            ],
                            output: {},
                          },
                      },
                      hooks: {},
                      roles: {
                        admin: {
                          permissions: {},
                          hooks: {},
                          requirements: {},
                          members: [s.auth.uid],
                        },
                      },
                      api: {},
                      "custom-script": "",
                    },
                    pages: {
                      home: {
                        text: "This is a blank XMBL. To edit, go to <a href='/admin?section=pages'>Pages Admin</a>",
                        styles: {
                          classes: "container p16",
                        },
                        published: true,
                        components: [],
                        pages: [],
                      },
                    },
                    users: {},
                    user: [
                      s.auth.uid,
                      "5nA8rryyPedDsIvtWmTD0pRbann2",
                      "7heXwzCbDQV0NX1IL9NRwyOCaNK2",
                    ],
                    itemTypes: [],
                    style: {
                      "custom-css": "",
                      "background-image": imageUrl,
                      "background-color": "#f2f2f0",
                      button: "",
                      color: "#191900",
                      container: "#e2e2e0",
                      indicate: "#bb8538",
                      navbar: "#f2f2f0",
                      "sub-container": "#f2f2f0",
                      success: "#93c83d",
                      update: "#452f91",
                      warn: "#e44233",
                    },
                    type: "fresh",
                    version: "v" + s.version,
                  },
                });
              };

              // Create welcome message for new admin
              setTimeout(() => {
                if (s.auth.uid) {
                  store.dispatch("create", {
                    type: "msg",
                    data: {
                      topic: "Welcome",
                      users: [s.auth.uid, "7heXwzCbDQV0NX1IL9NRwyOCaNK2"],
                      type: "welcome",
                      banter: {
                        [Date.now()]: {
                          text: "Welcome to XMBL. You can build anything! go to /admin to do it yourself or try the agent at /terminal",
                          userId: "7heXwzCbDQV0NX1IL9NRwyOCaNK2",
                        },
                      },
                      created: Date.now(),
                    },
                  });
                }
              }, 1000);

              let imageUrl = defaultBackground;
              try {
                const nasaPromise = store.dispatch("api", {
                  address:
                    "https://api.nasa.gov/planetary/apod?api_key=abg7Dc84znTXEuDGI80y1hYHiTqcRwXBeIt6JCtR",
                  verb: "get",
                });
                const timeoutPromise = new Promise((_, reject) =>
                  setTimeout(() => reject(new Error("NASA API timeout")), 1000)
                );
                const nasa = await Promise.race([nasaPromise, timeoutPromise]);
                imageUrl = nasa.data.url || defaultBackground;
              } catch {
                try {
                  const unsplash = await store.dispatch("api", {
                    address:
                      "https://api.unsplash.com/photos/random?client_id=-Z_FV8M_lDJt-EejYaZUhlUn9MLdrsJZ3tta2cqJKAY&orientation=landscape",
                    verb: "get",
                  });
                  imageUrl = unsplash.data.urls?.regular || defaultBackground;
                } catch {
                  /* fallback to default */
                }
              }
              createAppState(imageUrl);
              return s.app;
            }
          },
          (err) => {
            mu.setState(s, {
              prop: "show",
              prop2: "maintenance",
              val: err,
            });
          }
        );
      })
      .then(async () => {
        let typesindex = {};
        console.log("...setting type system lexicon...");
        fbBase
          .collection("index")
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              mu.set(s, { keys: ["index", doc.id], val: doc.data() });
            });
          });
        fbBaseLex
          .doc("types")
          .get()
          .then((d) => {
            Object.entries(d.data()).map(async (a) => {
              typesindex[a[1].f] = {};
              Object.entries(a[1]).map((b) => {
                typesindex[a[1].f][b[1]] = a[0] + b[0];
              });
            });
            Vue.set(s, "lexicon", typesindex);
          });
        console.log("...setting current user...", s.auth.uid);
        act.query(s, {
          type: "user",
          id: s.auth.uid,
        });
        // store.dispatch("query", {
        //   type: "user",
        //   id: s.auth.uid,
        // });
        return fbBase
          .collection("user")
          .get()
          .then(async (data) => {
            let users = {};
            data.docs.forEach(function (doc) {
              users[doc.id] = doc.data();
              users[doc.id].roles = users[doc.id].roles || [];
            });
            mu.setState(s, { prop: "userlist", val: users });
            mu.setState(s, { prop: "users", val: users });
            console.log(
              "...setting other users...",
              Object.keys(s.userlist).length
            );

            let hook = s.app.advanced.hooks && s.app.advanced.hooks.app;
            // let name = hook && (hook.fun || hook.get ? hook.get.name : f)
            hook &&
              act
                .run(s, {
                  from: "App loaded ",
                  if: hook.if || [],
                  fun: hook.fun,
                  payload: hook.getpayload || hook.payload || {},
                })
                .then((d) => d);
            // hook && store.dispatch('run', {
            //   from: 'App loaded ',
            //   if: hook.if || [],
            //   fun: hook.fun,
            //   payload: hook.getpayload || hook.payload || {},
            // }).then(d => d)
            Vue.set(s.show, "app", t);

            // Build function reference mapping {[name]: id}
            if (s.app.advanced && s.app.advanced.functions) {
              // Ensure ref.functions exists
              if (!s.ref.functions) {
                Vue.set(s.ref, "functions", {});
              }
              Object.keys(s.app.advanced.functions).forEach((funcId) => {
                const func = s.app.advanced.functions[funcId];
                if (func && func.name) {
                  Vue.set(s.ref.functions, func.name, funcId);
                }
              });
            }

            return console.groupEnd("Initializing state");
          });
      });
  },
  async ipfs(state, payload) {
    let type = store.dispatch("detecttype", payload).then((t) => t);
    let str = ["object", "array"].includes(await type)
      ? JSON.stringify(payload)
      : String(payload);
    return ut.ipfs(str);
  },
  notify(state, payload) {
    // Handle both object payload (from dispatch) and individual args (from direct call)
    let type, message, to, from, link, id, subMessage, actions;
    
    if (payload && typeof payload === 'object' && !Array.isArray(payload) && payload.type) {
      // Object payload from dispatch: { type, message, to, from, link, id, subMessage, actions }
      type = payload.type;
      message = payload.message || payload.text || '';
      to = payload.to || payload.users || [];
      from = payload.from;
      link = payload.link;
      id = payload.id;
      subMessage = payload.subMessage || '';
      actions = payload.actions || [];
    } else if (state && typeof state === 'object' && state.commit) {
      // First arg is context, second is payload object or first arg
      if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
        type = payload.type;
        message = payload.message || payload.text || '';
        to = payload.to || payload.users || [];
        from = payload.from;
        link = payload.link;
        id = payload.id;
        subMessage = payload.subMessage || '';
        actions = payload.actions || [];
      } else {
        // Individual args after context: (context, type, message, to, from, link, id, subMessage, actions)
        type = payload;
        message = arguments[2];
        to = arguments[3];
        from = arguments[4];
        link = arguments[5];
        id = arguments[6];
        subMessage = arguments[7];
        actions = arguments[8];
      }
    } else {
      // Direct call with individual args: (type, message, to, from, link, id, subMessage, actions)
      type = state;
      message = payload;
      to = arguments[2];
      from = arguments[3];
      link = arguments[4];
      id = arguments[5];
      subMessage = arguments[6];
      actions = arguments[7];
    }
    
    // Ensure type is string
    if (typeof type !== 'string') {
      type = 'system';
    }
    
    // Ensure to is array
    if (!Array.isArray(to)) {
      to = to ? [to] : [];
    }
    
    if (s.debug) mu.log("notify()", { type, message, to, from, link, id, subMessage, actions });
    var notifyObj = {
      type: "notification",
      data: {
        actions: actions || [],
        id: id || null,
        from: from || s.auth.uid || 'system',
        link: link || null,
        message: message || '',
        subMessage: subMessage || '',
        to: to || [],
        type: type || 'system', // types include specific item being watched, system, billing, events, jobs, crypto, and orders
      },
    };
    act.create(s, notifyObj);
    mu.point(s, {
      header: type,
      text: typeof message === 'object' ? JSON.stringify(message) : String(message || ''),
      link: link,
      sticky: t,
    });
    return notifyObj;
  },
  async if(state, payload) {
    console.log("running conditional |if|", payload);
    // if (payload.if) {
    // d('if', payload.if).then(x=>x)
    //todo check for and run functions
    //todo check for location
    let conditionalarray = [];
    const compare = {
      "==": (left, right) => (
        console.log(left, right, left == right), left == right
      ),
      "!=": (left, right) => left != right,
      ">": (left, right) => left > right,
      ">=": (left, right) => left >= right,
      "<": (left, right) => left < right,
      "<=": (left, right) => left <= right,
      includes: (left, right) => left.includes(right),
      excludes: (left, right) => !left.includes(right),
      // TODO add the other comparables, undefined compare, and deep checks
    };
    const resp = await Promise.all(
      payload.map(async (x, i) => {
        console.log("Mapping condition promises", { i, x });
        if (x.compare.length == 0) return true;
        // HERE finish conditional types
        const conditionaltypes = {
          value: async (v) => v,
          fn: async (v) =>
            await d("run", v).then(async (z) => {
              return await z;
            }),
          state: async (v) => _.get(s, v),
          local: async (v) => v,
        };

        if (i % 2 == 0) {
          const values = ["left", "right"].map(
            async (y) =>
              await conditionaltypes[x[y].type](x[y].value).then((v) => v)
          );
          const vals = await Promise.all(values).then((vls) => vls);

          if (x.compare in compare) {
            conditionalarray[i] = compare[x.compare](vals[0], vals[1]);
          }
          console.log({ conditionalarray });

          // let values = { left: x.left.value, right: x.right.value }

          // if (x.left.location) values.left = _.get(types, x.left.location)
          // if (x.right.location) values.right = _.get(types, x.right.location)
          // if (x.left.value) values.left = x.left.value
          // if (x.right.value) values.right = x.right.value
          // if (x.left.function) (x.left.function.from = payload.fun.name.toUpperCase() + ' in ' + payload.from, values.left = await store.dispatch('run', x.left.function).then(d => d))
          // if (x.right.function) (x.right.function.from = payload.fun.name + ' in ' + payload.from, values.right = await store.dispatch('run', x.right.function).then(d => d))
          // // TODO FIX bug for refactoring i.e. conditionalarray[i] = compare[x.compare](values.left, values.right);
          // if (x.compare in compare) conditionalarray[i] = compare[x.compare](values.left, values.right)
        } else conditionalarray[i] = x;
      })
    ).then(() => {
      let bool = t;
      let conditionalchain = {};
      let conditioncheck = async (logic, val) => {
        if (conditionalarray.length === 1) {
          bool = conditionalarray[0];
        } else if (!logic && !val) {
          if (conditionalarray[1] == "&&")
            bool = conditionalarray[0] && conditionalarray[2];
          if (conditionalarray[1] == "||")
            bool = conditionalarray[0] || conditionalarray[2];
        } else {
          if (logic == "&&") bool = bool && val;
          if (logic == "||") bool = bool || val;
        }
      };

      conditioncheck();
      conditionalarray.map((x, i) => {
        if (i < 3) return;
        if (i % 2 !== 0) conditionalchain.logic = x;
        if (i % 2 === 0) {
          conditionalchain.val = x;
          conditioncheck(conditionalchain.logic, conditionalchain.val);
        }
      });
      return bool
        ? (console.log("Conditions met"), t)
        : (console.log(
            "%c ERROR | Conditions not met.",
            "color: red",
            "Conditional",
            payload,
            conditionalarray
          ),
          f);
    });
    console.log("if response", { resp });
    return resp;
    // }
    // else return payload
  },
  async run(context, payload) {
    /* Running function
    Takes a pre-configured function from 
    ``` state.app.advanced.functions ```
    Each app function is a collection of 1 or more commands.
    Commands are typed: app, custom, etc. 
    They are assigned inputs from the user or from previous outputs */
    console.log(payload.fun);
    let runfn = ut.findcurrentfunction(payload.fun);
    const start = Date.now();

    if (payload.props) {
      this.props = payload.props;
    }
    if (!runfn && !payload.get)
      return console.info("Unavailable function from ", payload);

    // backwards compatibility
    if (!runfn && payload.get) {
      runfn = payload.get;
    }
    if (!payload.payload && payload.getpayload) {
      payload.payload = payload.getpayload;
    }

    // Setup logging group
    console.groupCollapsed(
      "%c (ƒ) ",
      "color:green",
      runfn.name.toUpperCase() + (payload.from ? " > from " + payload.from : "")
    );
    console.table(runfn.commands, ["type", "method"]);
    payload.if && console.info("Conditions", payload.if);
    console.info("Inputs", payload.payload);

    // TODO test asyncronicity

    // run hook function if present
    if (payload.hook) {
      await store.dispatch("run", payload.hook);
    }

    // Resolve p__ references in main payload object
    Object.entries(payload).forEach(([key, value]) => {
      if (typeof value === "string" && value.indexOf("p__") === 0) {
        let point = store.state;
        value
          .split("state.")[1]
          .split(".")
          .forEach((pathKey) => {
            point = !+pathKey ? point[pathKey] : point[+pathKey];
          });
        // Avoid circular references by converting to safe format
        try {
          payload[key] = JSON.parse(JSON.stringify(point));
        } catch (e) {
          payload[key] = String(point);
        }
      }
    });

    /* Get payload value from state
    STRATEGY 'p__' represents a point in state.
    */
    Object.entries(payload.payload).map((prop) => {
      if (typeof prop[1] === "string" && prop[1].indexOf("p__") === 0) {
        let point = store.state;
        prop[1]
          .split("state.")[1]
          .split(".")
          .forEach((key) => {
            point = !+key ? point[key] : point[+key];
          });
        // Avoid circular references by converting to safe format
        try {
          payload.payload[prop[0]] = JSON.parse(JSON.stringify(point));
        } catch (e) {
          payload.payload[prop[0]] = String(point);
        }
      } else if (
        typeof prop[1] === "string" &&
        prop[1].indexOf("prop__") === 0
      ) {
        payload.payload[prop[0]] = this.props[prop[1].split("prop__")[1]];
      }
    });

    // Setup runstate in/outs
    let runstate = {
      inputs: {
        payload: payload.payload,
      },
      state: runfn,
      outputs: {},
    };

    // Recursive function, calls each command in sequence then returns the last calculated value
    let ret = async (r, i) => {
      ((Array.isArray(r) && "array") || typeof r) !== runstate.outputs.push(r);

      if (runstate.state.commands[i + 1]) {
        console.log(
          "%c OUTPUT >",
          "color:blue",
          runstate.outputs[runstate.outputs.length - 1]
        );
        return fun(i + 1);
      } else {
        Vue.set(runstate, "outputs", runstate.outputs);
        console.groupEnd(
          "%c (ƒ in/out)",
          "color: blue",
          runfn.name.toUpperCase()
        );
        console.log(
          "%c (ƒ DONE)",
          "color: purple",
          runstate.state.name.toUpperCase(),
          "|",
          Date.now() - start,
          "ms",
          "|"
        );
        console.groupEnd(
          "%c (ƒ) ",
          "color:green",
          runfn.name.toUpperCase() +
            (payload.from ? " > from " + payload.from : "")
        );
        return runstate.outputs[runstate.outputs.length - 1];
      }
    };

    /* Command execution function 

    */
    let fun = async (i) => {
      let f = runstate.state.commands[i];
      let payload = i === 0 ? runstate.inputs.payload : {};

      // i+'___' is to allow multiple functions of same name
      Object.keys(runstate.inputs[i + "___" + f.method] || {}).map((k) => {
        if (
          f.inputs[k] &&
          f.inputs[k].target &&
          typeof f.inputs[k].target === "string" &&
          f.inputs[k].target.indexOf("p__") === 0
        ) {
          let point = store.state;
          f.inputs[k].target
            .split("state.")[1]
            .split(".")
            .forEach((key) => {
              point = !+key ? point[key] : point[+key];
            });
          // Avoid circular references by converting to safe format
          try {
            f.inputs[k].target = JSON.parse(JSON.stringify(point));
          } catch (e) {
            f.inputs[k].target = String(point);
          }
        }

        let output =
          (f.inputs[k] &&
            f.inputs[k].value &&
            f.inputs[k].value.split("state.")) ||
          runstate.outputs[runstate.outputs.length - 1];
        let objstr =
          output && output.length > 1
            ? _.get(runstate, output[1] || output[0])
            : undefined; // TODO check this works for n commands
        payload[k] =
          runstate.inputs.payload[f.inputs[k].value] ||
          _.get(this, f.inputs[k].value) ||
          objstr;

        payload[k] =
          f.inputs[k].value === "static"
            ? f.inputs[k].static
            : f.inputs[k].target
            ? _.get(payload[k], f.inputs[k].target)
            : payload[k];
      });
      let payloadarray = [];
      payload &&
        Object.entries(payload).map((x) => {
          if (f.inputs[x[0]]) {
            payloadarray[f.inputs[x[0]].order] =
              f.inputs[x[0]].value === "static" ? f.inputs[x[0]].static : x[1];
            payloadarray[f.inputs[x[0]].order] =
              payloadarray[f.inputs[x[0]].order] &&
              payloadarray[f.inputs[x[0]].order].fun &&
              payloadarray[f.inputs[x[0]].order].payload
                ? store.dispatch("run", payloadarray[f.inputs[x[0]].order])
                : payloadarray[f.inputs[x[0]].order];
            if (
              payloadarray[f.inputs[x[0]].order] &&
              payloadarray[f.inputs[x[0]].order].indexOf
            ) {
              if (payloadarray[f.inputs[x[0]].order].indexOf("p__") == 0) {
                let point = store.state;
                payloadarray[f.inputs[x[0]].order]
                  .split("state.")[1]
                  .split(".")
                  .forEach((key) => {
                    point = !+key ? point[key] : point[+key];
                  });
                // Avoid circular references by converting to safe format
                try {
                  payloadarray[f.inputs[x[0]].order] = JSON.parse(
                    JSON.stringify(point)
                  );
                } catch (e) {
                  payloadarray[f.inputs[x[0]].order] = String(point);
                }
              } else if (
                payloadarray[f.inputs[x[0]].order].indexOf("props__") == 0
              ) {
                // payloadarray[f.inputs[x[0]].order] = props[payloadarray[f.inputs[x[0]].order].split('props__')[1]]
              }
            }
          }
        });
      if (i == 0) {
        console.groupCollapsed(
          "%c (ƒ in/out)",
          "color: blue",
          runstate.state.name.toUpperCase()
        );
      }
      console.log(
        `%c ${i + 1} INPUT `,
        "color:orange",
        runstate.state.commands[i].method + "()",
        payloadarray
      );

      // Resolve p__ references in payload before dispatch/commit
      if (payload && typeof payload === "object") {
        Object.entries(payload).forEach(([key, value]) => {
          if (typeof value === "string" && value.indexOf("p__") === 0) {
            let point = store.state;
            value
              .split("state.")[1]
              .split(".")
              .forEach((pathKey) => {
                point = !+pathKey ? point[pathKey] : point[+pathKey];
              });
            // Avoid circular references by converting to safe format
            try {
              payload[key] = JSON.parse(JSON.stringify(point));
            } catch (e) {
              payload[key] = String(point);
            }
          }
        });
      }

      if (f.type === "app") {
        const [storePart, methodName] = f.method.split(".");

        // Handle await for previous async commands
        if (f.await && f.await.length > 0) {
          console.log(
            `%c AWAITING ${f.await.length} previous commands`,
            "color:purple",
            f.await
          );
          // Wait for all specified previous commands to complete
          for (const awaitIndex of f.await) {
            if (runstate.outputs[awaitIndex] === undefined) {
              console.warn(`Command ${awaitIndex} not found in outputs`);
            }
          }
        }

        if (storePart === "commit") {
          // Commit is synchronous and returns undefined, wrap in promise
          store.commit(methodName, payload);
          return ret(payload, i);
        } else {
          // Dispatch returns a promise
          return await store[storePart](methodName, payload).then((d) =>
            ret(d, i)
          );
        }
      }
      if (f.type === "custom") {
        let fn;
        let d;

        // Handle method calls like "Object.keys()", "Array.from()", "Object(arg).keys()", etc.
        if (f.method.includes(".")) {
          const parts = f.method.split(".");
          const methodName = parts[parts.length - 1].replace("()", "");
          const objectPath = parts.slice(0, -1).join(".");

          try {
            let obj;

            // Handle patterns like "Object(arg).keys()" where we need to evaluate the object expression
            if (objectPath.includes("(") && objectPath.includes(")")) {
              // This is a constructor call like "Object(arg)" - but we need to call the static method on the constructor
              const constructorName = objectPath.split("(")[0];
              const constructor = _.get(window, constructorName);
              if (typeof constructor === "function") {
                // For patterns like "Object(arg).keys()", we should call Object.keys(arg) instead
                // So we get the constructor and call the method with the argument
                const arg = payloadarray[0];
                fn = constructor[methodName];
                if (typeof fn === "function") {
                  d =
                    (await fn.call(constructor, arg)) ||
                    payloadarray[payloadarray.length - 1];
                } else {
                  console.error(
                    `Method ${methodName} not found on ${constructorName}`
                  );
                  d = payloadarray[payloadarray.length - 1];
                }
                return ret(d, i);
              } else {
                console.error(`Constructor ${constructorName} not found`);
                return ret(payloadarray[payloadarray.length - 1], i);
              }
            } else {
              // Handle static method calls like "Object.keys()"
              obj = _.get(window, objectPath);
            }

            if (obj && typeof obj[methodName] === "function") {
              fn = obj[methodName];
            } else {
              console.error(`Method ${methodName} not found on ${objectPath}`);
              return ret(payloadarray[payloadarray.length - 1], i);
            }
          } catch (e) {
            console.error(`Error accessing ${objectPath}.${methodName}:`, e);
            return ret(payloadarray[payloadarray.length - 1], i);
          }
        } else {
          // Handle direct function calls
          fn = _.get(window, f.method.replace("()", ""));
        }

        if (typeof fn === "function") {
          d =
            (await fn(...payloadarray)) ||
            payloadarray[payloadarray.length - 1];
        } else {
          console.error(`Function not found: ${f.method}`);
          d = payloadarray[payloadarray.length - 1];
        }

        return ret(d, i);
      }
      if (f.type === "function") {
        store.dispatch(
          "run",
          ...(payloadarray || payloadarray[payloadarray.length - 1])
        );
      }
    };

    // map commands to inputs
    runfn.commands.map((s, si) => {
      !runstate.inputs[s.method]
        ? Vue.set(runstate.inputs, si + "___" + s.method, {})
        : null;
      Object.keys(s.inputs || {}).map((i) =>
        Vue.set(runstate.inputs[si + "___" + s.method], i, "")
      );
    });
    runstate.outputs = [];

    // Conditional Checks
    if (payload.if || payload.conditionals) {
      let conditionals = payload.if || payload.conditionals;
      d("if", conditionals).then((x) => x);
      let conditionalarray = [];
      const compare = {
        ["=="](left, right) {
          return left === right;
        },
        ["!="](left, right) {
          return left !== right;
        },
        [">"](left, right) {
          return left > right;
        },
        [">="](left, right) {
          return left >= right;
        },
        ["<"](left, right) {
          return left < right;
        },
        ["<="](left, right) {
          return left <= right;
        },
        ["includes"](left, right) {
          return left.includes(right);
        },
        ["excludes"](left, right) {
          return !left.includes(right);
        },

        // TODO add the other comparables
      };
      const resp = await Promise.all(
        conditionals.map(async (x, i) => {
          if (i % 2 == 0) {
            let values = {};
            // TODO finish conditionals
            // if (x.left.location) values.left = _.get(types, x.left.location)
            // if (x.right.location) values.right = _.get(types, x.right.location)
            if (x.left.value) values.left = x.left.value;
            if (x.right.value) values.right = x.right.value;
            if (x.left.function)
              (x.left.function.from =
                runfn.name.toUpperCase() + " in " + payload.from),
                (values.left = await store
                  .dispatch("run", x.left.function)
                  .then((d) => d));
            if (x.right.function)
              (x.right.function.from = runfn.name + " in " + payload.from),
                (values.right = await store
                  .dispatch("run", x.right.function)
                  .then((d) => d));
            // TODO FIX bug for refactoring i.e. conditionalarray[i] = compare[x.compare](values.left, values.right);
            x.compare == "=="
              ? (conditionalarray[i] = compare["=="](values.left, values.right))
              : null;
            x.compare == "!="
              ? (conditionalarray[i] = compare["!="](values.left, values.right))
              : null;
            x.compare == ">"
              ? (conditionalarray[i] = compare[">"](values.left, values.right))
              : null;
            x.compare == ">="
              ? (conditionalarray[i] = compare[">="](values.left, values.right))
              : null;
            x.compare == "<"
              ? (conditionalarray[i] = compare["<"](values.left, values.right))
              : null;
            x.compare == "<="
              ? (conditionalarray[i] = compare["<="](values.left, values.right))
              : null;
            x.compare == "includes"
              ? (conditionalarray[i] = compare["includes"](
                  values.left,
                  values.right
                ))
              : null;
            x.compare == "excludes"
              ? (conditionalarray[i] = compare["excudes"](
                  values.left,
                  values.right
                ))
              : null;
          } else conditionalarray[i] = x;
        })
      ).then(() => {
        let bool = t;
        let conditionalchain = {};
        let conditioncheck = async (logic, val) => {
          if (conditionalarray.length === 1) {
            bool = conditionalarray[0];
          } else if (!logic && !val) {
            if (conditionalarray[1] == "&&")
              bool = conditionalarray[0] && conditionalarray[2];
            if (conditionalarray[1] == "||")
              bool = conditionalarray[0] || conditionalarray[2];
          } else {
            if (logic == "&&") bool = bool && val;
            if (logic == "||") bool = bool || val;
          }
        };

        conditioncheck();
        conditionalarray.map((x, i) => {
          if (i < 3) return;
          if (i % 2 !== 0) conditionalchain.logic = x;
          if (i % 2 === 0) {
            conditionalchain.val = x;
            conditioncheck(conditionalchain.logic, conditionalchain.val);
          }
        });
        return bool
          ? fun(0)
          : (console.log(
              "%c ERROR | Conditions not met.",
              "color: red",
              runfn.name,
              payload,
              conditionalarray
            ),
            f);
      });
      return resp;
    } else return fun(0);
  },
  async schedule(state, payload) {
    let commands = {
      set: async () => {
        let hash = await store
          .dispatch("util", { type: "hash", body: payload })
          .then((d) => d);
        return fbBaseState
          .doc("events")
          .get()
          .then(async (d) => {
            let thistime = +payload.time || +Date.now();
            if (d.exists) {
              let data = d.data();
              if (!data[+thistime - +d.data()["base"]]) {
                return fbBaseState
                  .doc("events")
                  .update({ [+thistime - +d.data()["base"]]: hash })
                  .then(() => store.dispatch("t", { hash, payload }));
              } else {
                payload.time = thistime + 1;
                return store.dispatch("schedule", payload);
              }
            } else {
              let now = Date.now();
              return fbBaseState
                .doc("events")
                .set({ base: now })
                .then(() =>
                  fbBaseState
                    .doc("events")
                    .set(
                      { [payload.time ? payload.time - now : "0"]: hash },
                      { merge: t }
                    )
                )
                .then(() => store.dispatch("t", { hash, payload }));
            }
          });
      },
      check: () => {
        console.log("check");
      },
      remove: () => {
        console.log("remove");
      },
      update: () => {
        console.log("update");
      },
    };
    return commands[payload.command]();
    // schedule function to be used throughout the ecosystem for time-sensitive activity,
    // including auctions, deliveries, and other events. (sync time with GMT atomic clock via cloud fn)
    // If the current time is within the range of the scheduled function, it will be executed.
    // payload: ['type', 'database id', 'itemid', 'function']
    // types: ['set', 'check', 'remove', 'update']
    /*
      *** db schedule example ***
      "www.xmbl.io" : {
        "itemid-2341325": {
          1093534523: {function config object} or "function name string"
        }
      }
    */
  },
  async secrets(state, payload) {
    if (payload.type === "share") {
      let hex = await ut
        .crypto("secret")
        .then((d) => d["str2hex"](payload.str));
      return await ut.crypto("secret").then((d) => {
        return d["share"](hex, +payload.shares, +payload.thresh);
      });
    }
    if (payload.type === "combine") {
      return await ut.crypto("secret").then((d) => {
        return d["hex2str"](d["combine"](payload.shares));
      });
    }
  },
  set(state, payload) {
    return store.commit("set", payload);
  },
  async getlocalstate() {
    if (!localStorage.getItem("state") || !localStorage.getItem("statehash"))
      return;
    if (
      (await act
        .util(st, { type: "hash", body: localStorage.getItem("state") })
        .then((h) => h)) == localStorage.getItem("statehash")
    ) {
      return (
        Object.entries(JSON.parse(localStorage.getItem("state"))).map((x) =>
          mu.set(st, { keys: [x[0]], val: x[1] })
        ),
        t
      );
    } else {
      return (
        console.error(`
          local state length: ${localStorage.getItem("state").length}
          local hash: ${localStorage.getItem("statehash")}
          actual hash: ${await act
            .util(st, { type: "hash", body: localStorage.getItem("state") })
            .then((h) => h)}
          hash match: ${
            (await act
              .util(st, { type: "hash", body: localStorage.getItem("state") })
              .then((h) => h)) == localStorage.getItem("statehash")
          }
        `),
        f
      );
    }
  },
  async setlocalstate() {
    let statestring = JSON.stringify(store.state);
    let statehash = store.dispatch("util", { type: "hash", body: statestring });
    localStorage.removeItem("state");
    localStorage.removeItem("statehash");
    localStorage.setItem("state", statestring);
    localStorage.setItem("statehash", await statehash.then((h) => h));
  },
  async token(state, payload) {
    const bitcoin = require("bitcoinjs-lib");
    const bip39 = require("bip39");
    const TESTNET = bitcoin.networks.testnet;
    if (payload.type == "nm") {
      return bip39.entropyToMnemonic(payload.pk);
    }
    if (payload.type === "log") {
      let nm = bip39.generateMnemonic();
      let hex = bip39.mnemonicToSeedSync(nm).toString("hex");
      const mnemonic = bip39.entropyToMnemonic(
        "b4579775af064467c5ddb71fa2a345ed"
      );
      console.log(mnemonic);
      let identity = {
        nm: nm,
        hex,
        buffer: bip39.mnemonicToSeedSync(nm),
        validate: {
          valid: bip39.validateMnemonic(nm),
          nmtoentropy: bip39.mnemonicToEntropy(nm),
        },
        generators: {
          nm: bip39.generateMnemonic.toString(),
          seed: bip39.mnemonicToSeedSync.toString(),
        },
      };
      return console.log("hello token", identity), identity;
    }
    if (payload.type === "check") {
      const Insight = require("bitcore-insight").Insight;
      let insight = new Insight("testnet");
      return insight.getUtxos(
        prompt("What address should we check?"),
        (err, utxos) => {
          if (err) return err;
          console.log(utxos);
        }
      );
    }
    if (payload.type === "nmtokey") {
      let nmtokey = bip39
        .mnemonicToSeedSync(
          "table pave boy barrel mass treat glow imitate remember proof truck powder"
        )
        .toString("hex");
      let nmtoentropy = bip39.mnemonicToEntropy(
        "table pave boy barrel mass treat glow imitate remember proof truck powder"
      );
      let seedphrase = bip39.entropyToMnemonic(nmtoentropy);
      console.log(nmtokey, nmtoentropy, seedphrase);
      return nmtokey;
    }
    if (payload.type === "createUser") {
      const TESTNET = bitcoin.networks.testnet;
      const keyPair = bitcoin.ECPair.makeRandom({ network: TESTNET });
      const { address } = bitcoin.payments.p2pkh({
        pubkey: keyPair.publicKey,
        network: TESTNET,
      });
      alert(
        JSON.stringify(
          {
            public: keyPair.__D.toString("hex"),
            private: keyPair.__Q.toString("hex"),
            address,
          },
          null,
          2
        )
      );
      let user = {
        public: keyPair.__D.toString("hex"),
        private: keyPair.__Q.toString("hex"),
        address,
        keyPair,
      };
      user.nmonic = bip39.entropyToMnemonic(keyPair.__Q.toString("hex"));
      return user;
    }
    if (payload.type === "createTx") {
      const bitcore = require("bitcore-lib");
      const Insight = require("bitcore-insight").Insight;
      let insight = new Insight("testnet");
      // let buff = '2e 98 b2 40 0e 76 2d e4 4e 33 4c f5 74 b1 ac 83 9e cf b9 52 0f cb 7c d8 f1 79 e9 46 ef 99 a3 d9'
      // let user = (async (exist) => {
      //   if (exist) return payload.txCreate.from
      //   else {
      //     const TESTNET = bitcoin.networks.testnet
      //     const keyPair = bitcoin.ECPair.makeRandom({ network: TESTNET })
      //     const { address } = await bitcoin.payments.p2pkh({ pubkey: await keyPair.publicKey, network: TESTNET  })(confirm('Use existing address?'))
      //     alert(JSON.stringify({address, keyPair}))
      //     return {address, keyPair}
      //   }
      // })(confirm('use existing address?'))
      insight.getUtxos(payload.tx.from, (err, utxos) => {
        if (err) console.error(err);
        console.info(utxos, payload);
        var privateKey = new bitcore.PrivateKey(payload.tx.sign, TESTNET);

        let tx = bitcore.Transaction();
        tx.from(utxos);
        tx.to(payload.tx.to, Number(payload.tx.amount));
        tx.change(payload.tx.from);
        tx.fee(Number(payload.tx.fee));
        tx.sign("help", privateKey, "true");
        // tx.sign(buff.replace(/\s+/g, ''))
        tx.serialize();
        alert(tx.toString(), payload.tx.toString());
        insight.broadcast(tx.toString(), async (error, txid) => {
          if (await error) return error;
          else console.log(await txid);
        });
      });
    }
  },
  async hashtable(state, payload) {
    // payload = {contract, type}
    console.log("hashtable", payload);
    // payload.contract is the hashable object {type,args,body,test}
    if (payload.contract) {
      const F = (args, body) => Function(...args, body);
      const sm =
        payload.contract.test &&
        F(payload.contract.args, payload.contract.body);
      sm && sm();
    }
    let thash = ""; // type hash
    let nonce = 0;
    let objsort = (obj) => Object.fromEntries(Object.entries(obj).sort()); // Object sort utility function
    // TODO change sorting function to accept lowercase and other normalizations
    return store
      .dispatch("util", { body: payload, type: "hash" })
      .then(async (hash) => {
        console.log("hash", hash);
        payload.hash = hash;
        async function micromining(hash) {
          return store
            .dispatch("util", { body: hash + nonce, type: "hash" })
            .then((ret) => {
              return ret.indexOf(payload.type) !== 0
                ? (nonce++, micromining(hash))
                : ret;
            });
        }
        thash = await micromining(hash, nonce).then((ret) => ret);
        payload.nonce = nonce; // set winning nonce
        payload.thash =
          (!payload.contract ||
            !payload.contract.test ||
            eval(payload.contract.test[0])() == payload.contract.test[1]) &&
          thash; // run test and set valid thash
        console.log(
          "found nonce:",
          nonce,
          payload,
          payload.contract &&
            payload.contract.test &&
            ("\nrunning test:",
            eval(payload.contract.test[0])() == payload.contract.test[1]),
          "\n\n\n\n"
        );
        store.state.lexicon[payload.type] =
          store.state.lexicon[payload.type] || [];
        store.state.lexicon[payload.type].push(payload.thash);
        store.state.hashtable[payload.thash] = payload;
        store.state.hashtable = objsort(store.state.hashtable);
        store.state.app.advanced.hashtable = store.state.hashtable;
        store.state.app.advanced.lexicon = store.state.lexicon;
        // Remove automatic app update to prevent reinit loop
        // store.dispatch('update', { type: 'app', data: store.state.app })
        return [hash, thash];
      });
  },
  async t(state, payload) {
    console.log("tokenizing in the future...", fbBaseTokens, payload);
    return store.dispatch("hashtable", payload).then((h) => {
      console.log("hashtable return hashes", h);
      return h;
    });
  },
  transact(state, payload) {
    if (store.state.debug) mu.log("transact()", payload);
    if (!store.state.auth.uid) {
      store.state.show.auth = t;
      return mu.log("Must be logged in", "Please authenticate.");
    }
    var approved = f;
    if (payload.type === "hashtable") {
      // payload.contract is the hashable object {type,args,body,test}
      let F = (args, body) => Function(...args, body);
      console.log(F);
      let thash = ""; // type hash
      let nonce = 0;
      return store
        .dispatch("util", { body: payload.contract, type: "hash" })
        .then(async (hash) => {
          payload.contract.hash = hash;
          async function micromining(hash) {
            return store
              .dispatch("util", { body: hash + nonce, type: "hash" })
              .then((ret) => {
                return ret.indexOf(payload.contract.type) !== 0
                  ? (nonce++, micromining(hash))
                  : ret;
              });
          }
          thash = await micromining(hash, nonce).then((ret) => ret);
          payload.contract.nonce = nonce; // set winning nonce
          payload.contract.thash =
            eval(payload.contract.test[0])() == payload.contract.test[1] &&
            thash; // run test and set valid thash
          console.log(
            "found nonce:",
            nonce,
            payload.contract,
            "\nrunning test:",
            eval(payload.contract.test[0])() == payload.contract.test[1],
            "\n\n\n\n"
          );
          store.state.lexicon[payload.contract.type] =
            store.state.lexicon[payload.contract.type] || [];
          store.state.lexicon[payload.contract.type].push(
            payload.contract.thash
          );
          store.state.hashtable[payload.contract.thash] = payload.contract;
          // store.state.hashtable = objsort(store.state.hashtable)
          console.log(JSON.stringify(store.state.hashtable, null, 3));
          store.state.app.advanced.hashtable = store.state.hashtable;
          store.state.app.advanced.lexicon = store.state.lexicon;
          // Remove automatic app update to prevent reinit loop
          // store.dispatch('update', { type: 'app', data: store.state.app })
          return hash;
        });
    } else if (payload.payment["payment-type"] === "PayPal") {
      approved = "paypal";
      act.update(state, {
        type: "orders",
        id: payload.orderId,
        data: {
          paid: "paypal",
        },
      });
      return "PayPal needs help";
    } else if (payload.payment["payment-type"] === "Credit") {
      // If going directly to Stripe Checkout, skip credit card processing
      // The card fields won't be present when using the "Pay with Stripe" button
      if (!payload.payment.number || !payload.payment.cvc || !payload.payment.month || !payload.payment.year) {
        console.log('[TRANSACT] Credit payment selected but no card details - using Stripe Checkout flow');
        // Return early - Stripe Checkout will be handled separately
        return Promise.resolve({ status: 'checkout_redirect' });
      }
      
      const cloudurl = store.state.cloudurl || 'https://us-central1-xmba-cloud-api.cloudfunctions.net/';
      return axios({
        method: "get",
        url: cloudurl + "keys",
      }).then((retKeys) => {
        const cardInfo = {
          number: payload.payment.number.toString(),
          exp_month:
            payload.payment.month.length === 1
              ? "0" + payload.payment.month
              : payload.payment.month,
          exp_year: "20" + payload.payment.year,
          cvc: payload.payment.cvc.toString(),
        };
        var encryptedPackage = QuickEncrypt.encrypt(
          JSON.stringify(cardInfo),
          retKeys.data
        );
        mu.log("\ntransaction:\n", payload.orderId);
        return axios
          .post(cloudurl + "charge", {
            token: encryptedPackage,
            pubKey: retKeys.data,
            amount: Number(payload.fullOrder.total) * 100,
            currency: "usd",
            description: payload.fullOrder.id,
          }, {
            validateStatus: function (status) {
              return status < 500; // Don't throw on 4xx errors, let us handle them
            }
          })
          .then((retCharge) => {
            console.log('[PAYMENT] Charge response:', retCharge.data, 'Status:', retCharge.status);
            if (retCharge.status === 400 || retCharge.data.status === "failed") {
              // Payment failed (e.g., card declined) - this is what we want!
              const errorMsg = retCharge.data.error || retCharge.data.message || 'Payment failed';
              console.log('[PAYMENT] Card declined error:', errorMsg);
              approved = f;
              mu.log("charge failed:", retCharge.data);
              act.notify(
                "billing",
                "Transaction failed: " + errorMsg,
                [store.state.auth.uid],
                "Stripe",
                `/orders/${payload.orderId}`,
                payload.orderId
              );
              throw new Error(errorMsg);
            }
            
            // Handle requires_action status (3D Secure authentication needed)
            if (retCharge.data.status === "requires_action" && retCharge.data.client_secret) {
              console.log('[PAYMENT] Payment requires authentication, redirecting to Stripe...');
              // Store payment intent ID for status check after redirect
              window.localStorage.setItem('pendingPaymentIntent', retCharge.data.id);
              window.localStorage.setItem('pendingOrderId', payload.orderId);
              // Redirect to Stripe's authentication page
              // Stripe will redirect back to return_url after authentication
              const returnUrl = window.location.origin + '/orders/' + payload.orderId;
              window.location.href = `https://hooks.stripe.com/redirect/authenticate/${retCharge.data.client_secret}?redirect_to=${encodeURIComponent(returnUrl)}`;
              return retCharge; // Don't update order yet, wait for redirect
            }
            
            approved = retCharge.data.status === "succeeded" ? t : f;
            if (approved) {
              act.update(state, {
                type: "orders",
                id: payload.orderId,
                data: {
                  paid: "credit card",
                },
              });
            }
            mu.log("charge went through", retCharge.data);
            act.notify(
              "billing",
              "Transaction " +
                (retCharge.data.message || retCharge.data.status),
              [store.state.auth.uid],
              "Stripe",
              `/orders/${payload.orderId}`,
              payload.orderId
            );
            return retCharge;
          }).catch((chargeError) => {
            console.error('[PAYMENT] Charge error:', chargeError);
            approved = f;
            const errorMsg = chargeError.response?.data?.error || chargeError.response?.data?.message || chargeError.message || 'Payment failed';
            console.log('[PAYMENT] Error message:', errorMsg);
            mu.log("charge error:", chargeError);
            
            // Fallback to Stripe Checkout Session
            console.log('[PAYMENT] Falling back to Stripe Checkout...');
            const cloudurl = store.state.cloudurl || 'https://us-central1-xmba-cloud-api.cloudfunctions.net/';
            const app = store.state.app?.basics?.['app name'] || 'xmbl';
            
            return axios.post(cloudurl + 'stripecheckout', {
              orderId: payload.orderId,
              amount: Number(payload.fullOrder.total),
              currency: 'usd',
              description: payload.fullOrder.id,
              database: app
            }).then((checkoutResponse) => {
              console.log('[PAYMENT] Checkout session created:', checkoutResponse.data);
              if (checkoutResponse.data.url) {
                // Redirect to Stripe Checkout
                window.location.href = checkoutResponse.data.url;
                return checkoutResponse;
              } else {
                throw new Error('No checkout URL received');
              }
            }).catch((checkoutError) => {
              console.error('[PAYMENT] Checkout fallback failed:', checkoutError);
              console.error('[PAYMENT] Checkout error response:', checkoutError.response?.data);
              console.error('[PAYMENT] Checkout error status:', checkoutError.response?.status);
              const checkoutErrorMsg = checkoutError.response?.data?.error || checkoutError.message || 'Unknown error';
              act.notify(
                "billing",
                "Transaction failed: " + errorMsg + ". Checkout fallback also failed: " + checkoutErrorMsg,
                [store.state.auth.uid],
                "Stripe",
                `/orders/${payload.orderId}`,
                payload.orderId
              );
              throw chargeError; // Throw original error
            });
          });
      });
    } else if (payload.payment["payment-type"] === "Crypto") {
      let cbObj = {
        name: store.state.auth.uid,
        description: payload.orderId,
        pricing_type: "fixed_price",
        local_price: {
          amount: payload.fullOrder.total,
          currency: "USD",
        },
      };
      return store
        .dispatch("api", {
          address: store.state.cloudurl + "coinbasecharge",
          verb: "post",
          data: cbObj,
        })
        .then((r) => {
          if (r && r.data) {
            mu.log("crypto charge", r.data);
            // Handle coinbase charge response
            if (r.data.data && r.data.data.hosted_url) {
              // Update order with payment info
              act.update(state, {
                type: "orders",
                id: payload.orderId,
                data: {
                  payment: {
                    order: payload.payment,
                    charge: r.data.data,
                  },
                  paid: "NEW",
                },
              });
            }
            return r;
          } else {
            console.error("Invalid response from coinbasecharge:", r);
            throw new Error("Invalid response from payment service");
          }
        })
        .catch((error) => {
          console.error("Error processing crypto payment:", error);
          mu.log("crypto charge error", error.message || error);
          throw error;
        });
    }
  },
  upload(state, payload) {
    let time = Date.now(),
      hash;
    store.commit("point", {
      header: "Uploading file",
      text: "Authenticating and checking tokenisation",
      sticky: t,
      time,
    });

    if (!store.state.auth.uid) {
      store.state.show.auth = t;
      return mu.log("Must be logged in", "Please authenticate, mfkr.");
    }

    if (store.state.debug) mu.log("upload()", payload);

    var storageRef = storage.ref();
    var reader = new FileReader();

    reader.onload = async function (event) {
      var data = event.target.result; // the file
      hash = await store.dispatch("worker", data).then((h) => h);
      const name = encodeURIComponent(payload.files[0].name.norm());

      // make firebase ref obj
      var fileRef = storageRef
        .child(store.state.auth.uid)
        .child(hash)
        .child(name);

      store.commit("point", {
        header: "Uploading file",
        text: "Connecting to file host",
        sticky: t,
        time,
      });

      // put file to firebase
      return fileRef.put(payload.files[0]).then(async function (snapshot) {
        let file = snapshot.metadata;
        await snapshot.ref.getDownloadURL().then((url) => {
          // set-up file object
          let fileobj = {
            [hash]: {
              url: [url],
              type: file.contentType,
              name: file.name,
              size: file.size,
              hash,
            },
          };

          // tokenize file
          store
            .dispatch("t", {
              type: store.state.lexicon.create.file,
              payload: fileobj[hash],
            })
            .then(async (h) => {
              file.token = h;

              store.dispatch("update", {
                type: "files",
                hash,
                data: { ...fileobj[hash], token: file.token },
              });

              // set fileobj to user's collection
              fbusersbase
                .collection(store.state.auth.uid)
                .doc("files")
                .set(fileobj, { merge: t });

              store.state.lastuploadurls.push(url);
              store.state.lastuploadhash.push(hash);

              store.commit("set", {
                keys: ["lastuploadurls"],
                val: store.state.lastuploadurls,
              });
              store.commit("set", {
                keys: ["lastuploadhash"],
                val: store.state.lastuploadhash,
              });

              store.commit("point", {
                header: "Upload Complete",
                text: "Your file is now available",
                link: url,
                speed: 5000,
              });

              console.log(
                await store.dispatch("ipfs", payload.files[0]).then((h) => h)
              );
              return await store
                .dispatch("query", { id: store.state.uid, type: "user" })
                .then(() => snapshot);
            });
        });
      });
    };

    return reader.readAsBinaryString(payload.files[0]);
  },
  validjson(state, str) {
    try {
      if (+str + +str == +str * 2) return f;
      JSON.parse(str);
      return t;
    } catch (e) {
      return f;
    }
  },
  worker(state, str) {
    return (async () => {
      const worker = new Worker("/worker.js");
      try {
        // WebWorkers use `postMessage` and therefore work with Comlink.
        const obj = Comlink.wrap(worker);
        // console.log(str, 'obj.hashes', await obj.hashes(str).then(x => x));
        // alert(`Counter: ${obj.counter}`);
        const result = await obj.hashes(str);
        return result;
      } finally {
        worker.terminate();
      }
    })();
  },
};
export const store = new vuex.Store({
  state: st,
  mutations: mu,
  actions: act,
  modules: {
    agent,
  },
});
const s = store.state,
  d = store.dispatch,
  m = store.commit;
const mp = (a, b, c) => m("point", { header: a, text: b, sticky: c });
